<template>
  <div>
    <div class="event-properties-item">
      <div class="event-label">目标</div>
      <div>
        <el-input style="width:280px" size="mini" v-model="event.params" placeholder="要修改的目标ID或Tag，默认组件自身"></el-input>
      </div>
    </div>

    <div>
      <div class="event-properties-addkeyval-header">
        <div class="header-item">key</div>
        <div class="header-item">value</div>
        <div class="header-item">
          <el-button size="mini" @click="addProp">添加修改属性</el-button>
        </div>
      </div>

      <div class="prop-item" v-for="(item, index) in setProps" :key="index">
        <div class="setprops-list">
          <!-- <el-select
            v-model="item.key"
            placeholder="请选择"
            size="mini"
            @change="propsSelect"
          >
            <el-option
              v-for="propItem in setPropsList"
              :key="propItem.key"
              :label="propItem.label"
              :value="propItem.key"
            >
            </el-option>
          </el-select> -->

          <el-autocomplete
            class="inline-input"
            v-model="item.key"
            :fetch-suggestions="querySearch"
            placeholder="请输入key"
            size="mini"
            @change="propsSelect"
          >
          <div slot-scope="{item}">{{ item.label }}</div>
        </el-autocomplete>
        </div>
        <div class="setprops-list">
          <el-input
            size="mini"
            v-model="item._value"
            placeholder="请输入值"
            @change="updateProp"
          ></el-input>
        </div>
        <div class="setprops-list">
          <el-button size="mini" @click="removeItem(index)">删除</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { valueType } from '../../utils/dataDefine'

export default {
  props: ["uuid", "technology"],
  data() {
    return {
      setPropsList: [
        {
          key: "background",
          label: "背景颜色",
          value:"background"
        },
        {
          key: "color",
          label: "颜色",
          value:"color"
        },
        {
          key: "text",
          label: "文字",
          value:"text"
        },
        {
          key: "width",
          label: "宽度",
          value:"width"
        },
        {
          key: "height",
          label: "高度",
          value:"height"
        },
        {
          key: "visible",
          label: "显示",
          value:"visible"
        },
        {
          key: "progress",
          label: "进度",
          value:"progress"
        },
        {
          key: "value",
          label: "值",
          value:"value"
        },
        {
          key: "showChild",
          label: "显示子元素",
          value:"showChild"
        },
      ],
      value: {},
      setProps: [],
      event: null,
    };
  },
  created() {
    this.event = this.technology.getEvent(this.uuid);
    if (!this.event.setProps) {
      this.event.setProps = [];
    }
    this.setProps = this.event.setProps
  },
  methods: {
    querySearch(queryString, cb) {
      var restaurants = this.setPropsList;
      var results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (
          restaurant.label.toLowerCase().indexOf(queryString.toLowerCase()) ===
          0 || restaurant.key.toLowerCase().indexOf(queryString.toLowerCase()) ===
          0
        );
      };
    },
    updateProp(e) {
      this.setProps.forEach((item) => {
        // 转换数据类型
        this.value[item.key] = valueType(item._value);
      });
      this.event.value = this.value;
      this.propsSelect();
    },
    propsSelect() {
      this.event.setProps = this.setProps;
    },
    addProp() {
      let obj = {
        key: "",
        value: "",
      };
      this.setProps.push(obj);
    },
    removeItem(index) {
      this.setProps.splice(index, 1);
      this.propsSelect();
    },
  },
};
</script>
<style lang="scss" scoped>
.event-properties-item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  width: 100%;
  .event-label {
    width: 120px;
  }
}
.event-properties-addkeyval-header {
  display: flex;
  width: 100%;
  justify-content: space-between;
  .header-item {
    flex: 1;
    display: flex;
    align-items: center;
  }
}
.prop-item {
  display: flex;
  width: 100%;
  justify-content: space-between;
  .setprops-list {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 10px;
    padding-right: 10px;
  }
}
</style>